var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-divider', {
    staticClass: "custom-divider"
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.customLabelIcon')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.labelIconClass')
    }
  }, [_c('icon-picker', {
    model: {
      value: (_vm.optionModel.labelIconClass),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "labelIconClass", $$v)
      },
      expression: "optionModel.labelIconClass"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345e7fe5","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/labelIconClass-editor.vue
// module id = null
// module chunks = 